import React from 'react';
import { ExportField } from '../../types';

interface ExportControlsProps {
  exportFields: ExportField;
  onExportFieldChange: (field: keyof ExportField, checked: boolean) => void;
  onExportSelected: () => void;
  onExportAll: () => void;
  onExportAppleConnect: () => void;
}

const ExportControls: React.FC<ExportControlsProps> = ({
  exportFields,
  onExportFieldChange,
  onExportSelected,
  onExportAll,
  onExportAppleConnect
}) => {
  const fieldOptions = [
    { key: 'firstName' as keyof ExportField, label: 'First Name' },
    { key: 'lastName' as keyof ExportField, label: 'Last Name' },
    { key: 'email' as keyof ExportField, label: 'Email' },
    { key: 'platform' as keyof ExportField, label: 'Platform' },
    { key: 'experienceYears' as keyof ExportField, label: 'Experience' },
    { key: 'timestamp' as keyof ExportField, label: 'Date' },
    { key: 'status' as keyof ExportField, label: 'Status' },
    { key: 'testflightEmail' as keyof ExportField, label: 'TestFlight Email' },
    { key: 'notes' as keyof ExportField, label: 'Notes' }
  ];

  return (
    <div className="export-controls mb-4">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">
            <span>📥</span>
            Export Data
          </h4>
          <p className="card-description">Export selected or all signup data</p>
        </div>
        
        <div className="mb-4">
          <h5 className="font-semibold mb-3">Select Fields to Export</h5>
          <div className="field-selector">
            {fieldOptions.map(option => (
              <label key={option.key}>
                <input 
                  type="checkbox" 
                  checked={exportFields[option.key]}
                  onChange={(e) => onExportFieldChange(option.key, e.target.checked)}
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
        
        <div className="flex gap-4">
          <button className="btn btn-primary" onClick={onExportSelected}>
            <span>📊</span>
            Export Selected to CSV
          </button>
          <button className="btn btn-success" onClick={onExportAll}>
            <span>📊</span>
            Export All to CSV
          </button>
          <button className="btn btn-warning" onClick={onExportAppleConnect}>
            <span>🍎</span>
            Apple Connect CSV
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportControls;
